import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { CatalogueProduct } from '../../../api/products/catalogue';
import { isAuthenticatedState } from '../../../api/appState';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
export interface CataloguePageListContentItemCardInlineParametersProps
  extends StandardDivProps<CataloguePageListContentItemCardInlineParametersClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardInlineParametersClassKey = 'root' | 'label';

const themeSettings = { name: 'CataloguePageListContentItemCardInlineParameters' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListContentItemCardInlineParametersClassKey, {}>({
      root: {
        ...theme.typography.caption,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
      label: {
        paddingRight: '1ch',
        color: theme.palette.text.hint,
      },
    }),
  themeSettings,
);

const CataloguePageListContentItemCardInlineParameters = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardInlineParametersProps
>(({ className, classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const t = useTranslateWithFallback();
  const isAuthenticated = useRecoilValue(isAuthenticatedState);

  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      <div>
        <span className={classes.label}>{t('common/code')}:</span>
        <span>{product.sku || ''}</span>
      </div>
      {isAuthenticated && (
        <div>
          <span className={classes.label}>{t('productPage/minOrderableQuantity')}:</span>
          <span>{product.quantityStep}</span>
        </div>
      )}
    </div>
  );
});

CataloguePageListContentItemCardInlineParameters.displayName = 'CataloguePageListContentItemCardInlineParameters';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardInlineParameters);
